import getRandomlyTranslatedAndZoomedCameraProperties from './getRandomlyTranslatedAndZoomedCameraProperties';
import createObliqueAngleController from './createObliqueAngleController';

const camera = {
  getRandomlyTranslatedAndZoomedCameraProperties,
  createObliqueAngleController,
};

export default camera;
export { createObliqueAngleController };
